export const WorkScheduleActionTypes = {
  API_RESPONSE_SUCCESS: '@@workSchedule/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@workSchedule/API_RESPONSE_ERROR',
  GET_WORK_SCHEDULE_LIST: '@@workSchedule/GET_WORK_SCHEDULE_LIST',
  GET_WORK_SCHEDULE_SHIFT_NAME_LIST: '@@workSchedule/GET_WORK_SCHEDULE_SHIFT_NAME_LIST',
  GET_WORK_SCHEDULE_BY_DAY_OF_WEEK_LIST: '@@workSchedule/GET_WORK_SCHEDULE_BY_DAY_OF_WEEK_LIST',
  GET_WORK_SCHEDULE_BY_DAY: '@@workSCHEDULE/GET_WORK_SCHEDULE_BY_DAY',
  GET_WORK_SCHEDULE_OPTION: '@@workSchedule/GET_WORK_SCHEDULE_OPTION',
  GET_WORK_SCHEDULE_BY_SHIFT: '@@workSchedule/GET_WORK_SCHEDULE_BY_SHIFT',
  RESET_WORK_SCHEDULE_LIST: '@@workSchedule/RESET_WORK_SCHEDULE_LIST',
  RESET_WORK_SCHEDULE_SHIFT_NAME_LIST: '@@workSchedule/RESET_WORK_SCHEDULE_SHIFT_NAME_LIST',
}